import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { FocusService, HREF } from '@core';
import { OrderPlacingResponse } from '@models';

function getTypedState<T>(router: Router): T | undefined {
  const navigation = router.currentNavigation();
  return navigation?.extras.state as T | undefined;
}

@Component({
  selector: 'app-checkout-confirmation-page',
  templateUrl: './checkout-confirmation-page.component.html',
  styleUrls: ['./checkout-confirmation-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, MatButtonModule, RouterModule],
})
export class CheckoutConfirmationPageComponent {
  href = HREF;
  router = inject(Router);

  state = getTypedState<OrderPlacingResponse>(this.router);

  constructor() {
    const focusService = inject(FocusService);
    setTimeout(() => {
      focusService.focusHeaderFirstItem();
    }, 1000);
  }

  // RCP-442: order history disabled
  // goToOrders(): void {
  //   this.router.navigate([HREF.ORDERS]);
  // }
}
